import React from 'react'
import icon1 from '../assets/images/client/icon1.png';
import icon2 from '../assets/images/client/icon2.png';
import icon3 from '../assets/images/client/icon3.png';
import icon4 from '../assets/images/client/icon4.png';
import icon5 from '../assets/images/client/icon5.png';
import icon6 from '../assets/images/client/icon6.png';
import icon7 from '../assets/images/client/icon7.png';
import icon8 from '../assets/images/client/icon8.jpg';
import { Link } from 'react-router-dom';

const Clients = () => {
    const clientIcons = [
        { src: icon1, alt: "Client1" },
        { src: icon2, alt: "Client2" },
        { src: icon3, alt: "Client3" },
        { src: icon4, alt: "Client4" },
        { src: icon5, alt: "Client5" },
        { src: icon6, alt: "Client6" },
        { src: icon7, alt: "Client7" },
        { src: icon8, alt: "Client8" },
    ];

    return (
        <>
            <div className="bg client-bg">
                <h1>Our Clients</h1>
            </div>
            <section className="pb-24 pt-20">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mb-20 text-center">
                        <h1 className="text-4xl text-gray-900 text-center font-bold">We work with the best partners</h1>
                    </div>
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-4">
                        {clientIcons.map((client, index) => (
                            <Link
                                key={index}
                                className="flex justify-center items-center border border-solid border-gray-200 shadow-sm h-32 rounded-2xl">
                                <img className="w-full h-24 object-contain rounded-lg" src={client.src} alt={client.alt} />
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Clients